// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__2nOR1","col":"styles_col__1ecy2"};